import React from 'react'
import {
  Container,
  Header,
} from 'semantic-ui-react'
import {
  withRouter
} from 'react-router'
import SelectionSettingsForm from './SelectionSettingsForm.js'

const NewSelection = ({history, mode, selection, selections, typePresets, onCreate}) => {
  return (
    <Container text style={{ marginTop: '7em', padding: '10px', background: 'white #fef0e7' }}>
      <Header as='h1' style={{color: '#f2711c'}}>
        Create New Selection
      </Header>
      <SelectionSettingsForm
        selections={selections}
        selection={selection}
        typePresets={typePresets}
        onSubmit={(id,s)=>{onCreate(s); history.push('/selection/'+s.id)}}
        submitButtonName='Create'
      />
    </Container>
  );
}

export default withRouter(NewSelection)